import ComparisonTable from "../../../../contents/_includes/session-replay/comparison-table.mdx";
import * as React from 'react';
export default {
  ComparisonTable,
  React
};